var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 52,
    viewBox: "0 0 67 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_2646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.001 45.9801C67.001 47.2912 65.7974 48.4915 63.3901 49.5994C61.3162 50.5597 59.52 51.0582 58.0201 51.0398C54.298 51.0398 51.0204 49.1562 48.2058 45.3892L33.0214 25.1506L19.4481 46.4233C16.5224 50.1349 12.93 52 8.6339 52C6.80067 51.9815 5.00447 51.5938 3.3379 50.8551C1.1158 49.9503 0.00474955 48.7869 0.00474955 47.3466C-0.0137679 47.0142 0.060302 46.7003 0.208442 46.4233L25.4107 3.91477C27.4847 1.31108 29.9661 0 32.8733 0C35.7805 0 38.373 1.31108 40.447 3.93324L66.8899 45.3523C66.964 45.5554 67.001 45.777 67.001 45.9801Z",
    fill: "url(#paint0_linear_494_2646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0039 25.2243L43.3367 8.5127L66.3354 44.5766C66.3354 44.5766 68.076 46.1462 65.9095 48.0851C63.7429 50.0241 59.8913 50.9658 58.8914 51.0951C57.8914 51.2243 54.1509 51.2613 51.1511 48.6022C49.0771 46.7556 48.3179 45.6107 48.3179 45.6107L39.1147 33.4047L33.0039 25.2243Z",
    fill: "url(#paint1_linear_494_2646)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_494_2646",
    x1: 27.7754,
    y1: 57.2074,
    x2: 53.8888,
    y2: 8.87279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9D06FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1337EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_494_2646",
    x1: 44.8495,
    y1: 45.5645,
    x2: 59.8555,
    y2: 17.2733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#08FFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1414F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_2646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignLogo);
export default __webpack_public_path__ + "static/media/campaign-logo.51475b953763422ac9e73f5a6587ea45.svg";
export { ForwardRef as ReactComponent };